<div class="generic-info">
  <img [src]="dataMessage.image" />
  <h1 [style.color]="titleColor()">{{ title }}</h1>
  <h1 class="marginTopGeneric" [style.color]="titleColor()">{{ title2 }}</h1>
  <div class="generic-info-message">{{ message }}</div>
  <div class="generic-info-message" *ngIf="message2"><br><br>{{ message2 }}</div>
</div>
